const TOTAL_QUANTITY_ONLY = {
  label: 'Total Quantity only',
  value: 'quantity',
}
const COLOR_AND_SIZE = { label: 'by Color and Size', value: 'color_size' }
const BY_DESTINATION = { label: 'by Destination', value: 'destination' }

export const quantity_breakdown_types = [
  TOTAL_QUANTITY_ONLY,
  COLOR_AND_SIZE,
  BY_DESTINATION,
]

export const quantity_total_only_types = [TOTAL_QUANTITY_ONLY]

export const quantity_breakdown_types_obj = {
  TOTAL_QUANTITY_ONLY: 'quantity',
  BY_COLOR_AND_SIZE: 'color_size',
  BY_DESTINATION: 'destination',
  CUSTOM_ITEM: 'custom_item',
}
